import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import { putInspectionSchedule, Body } from "../../api/inspections/putInspectionSchedule";

export default function useInspectionScheduledUpdate({ id }: { id: string | number }) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [scheduleInspectionMutation, scheduleInspectionMutationState] = useMutation(
    putInspectionSchedule(networkHeaders, id.toString() ?? ""),
    {
      onSuccess: () => queryCache.invalidateQueries(),
    },
  );

  return {
    scheduleInspection: (data: Body) => {
      scheduleInspectionMutation(data);
    },
    isLoading: scheduleInspectionMutationState.isLoading,
  };
}
